/*
 * The values for organization-level settings governing enforcement of approved locations for trip addresses.
 *
 * APPROVED_LOCATION_MODES: persisted values used across the app and server
 * - OFF ('off'): No enforcement. Pickup/drop-off can be any address.
 * - SEMI_STRICT ('semi-strict'): At least one address (pickup or drop-off) must be approved.
 * - STRICT ('strict'): Both pickup and drop-off must be approved.
 *
 * Shared copy for UX notifications explaining the policy to users.
 */
export const APPROVED_LOCATION_MODES = Object.freeze({
  OFF: 'off',
  SEMI_STRICT: 'semi-strict',
  STRICT: 'strict',
});

/**
 * The user-friendly labels for the approved location modes.
 */
export const APPROVED_LOCATION_MODE_LABELS = Object.freeze({
  [APPROVED_LOCATION_MODES.OFF]: 'Off',
  [APPROVED_LOCATION_MODES.SEMI_STRICT]: 'Semi-Strict',
  [APPROVED_LOCATION_MODES.STRICT]: 'Strict',
});

/**
 * Shared properties for toast notification copy for informing users about approved location restrictions.
 * Used in UI toast notifications and dialogs to explain the organization's approved location policy.
 *
 * Properties:
 * - TITLE: The heading/title for the notification.
 * - STRICT_MESSAGE: Message shown when both pickup and drop-off must be approved locations.
 * - SEMI_STRICT_MESSAGE: Message shown when at least one address (pickup or drop-off) must be approved.
 */
export const APPROVED_LOCATION_TOAST_PROPS = Object.freeze({
  TITLE: 'Approved Location Restriction',
  SEMI_STRICT_MESSAGE:
    "At least one address (pickup or drop-off) must be included in your health plan's list of approved locations.",
  STRICT_MESSAGE:
    "Pickup and drop-off addresses must be included in your health plan's list of approved locations.",
});
